// Libraries
import { useTranslation } from "react-i18next";

// Material UI
import { Stack, Typography } from "@mui/material";

// Styles
import { styles as textStyles } from "Common/Styles/TextStyles";

const MBSAuthFormHeader = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} alignItems="center">
      <Stack spacing={0.5} alignItems="center">
        <Typography variant="h1" sx={textStyles.poppinsTitle}>
          {t("mbsAuth.portalTitleLine1")}
        </Typography>
        <Typography variant="h1" sx={textStyles.poppinsTitle}>
          {t("mbsAuth.portalTitleLine2")}
        </Typography>
      </Stack>
      <Stack spacing={1} alignItems="center">
        <Typography variant="h6" color="textPrimary" textAlign="center">
          {title}
        </Typography>

        {description && (
          <Typography variant="body2" color="textSecondary" textAlign="center">
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default MBSAuthFormHeader;
